import AccountKeyBanner from './AccountKeyBanner'

export default AccountKeyBanner
